import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DrawAttention, Input } from '@cgn/framework-ui-components/v2';
import { HelpIcon } from '@cgn/framework-ui-components/googleOutlinedIcons';
import { INFO_CAMPI_ADDIZIONALI } from '../../Shared/messages';
import { requestFocus } from '../../Shared/Utils';

const MAX_AUX_FIELD_LENGTH = 250;
const CampoAuxInputProps = { maxLength: MAX_AUX_FIELD_LENGTH };
const CampoAuxValidations = [{
  rule: 'maxLength',
  maxLength: MAX_AUX_FIELD_LENGTH + 1, // !!!
  message: `Lunghezza massima ${MAX_AUX_FIELD_LENGTH} caratteri`,
}];

/**
*/
const DatiAddizionali = ({
  campoAux1, etichetta1, etichetta2, campoAux2, onChangeCampo1, onChangeCampo2,
}) => {
  const campoAux1Ref = useRef();
  const campoAux2Ref = useRef();

  useEffect(() => {
    // eseguo per inizializzazione
    campoAux1Ref && campoAux1Ref.current && campoAux1Ref.current.setValue(campoAux1);
    campoAux2Ref && campoAux2Ref.current && campoAux2Ref.current.setValue(campoAux2);
    requestFocus(campoAux1Ref);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!etichetta1 && !etichetta2) return null;

  return (
    <>
      <span className="helpdesk-frontend-informazioni-aggiuntive__label text-bold">
        Dati addizionali
        <DrawAttention
          className="helpdesk-frontend-informazioni-aggiuntive__label_tooltip"
          tooltipContent={INFO_CAMPI_ADDIZIONALI}
          type="info"
          icon={<HelpIcon />}
        />
      </span>

      {
        etichetta1
        && (
          <Input
            className="helpdesk-frontend-scelta-servizio__form-item"
            ref={campoAux1Ref}
            title={etichetta1}
            onChangeValue={onChangeCampo1}
            inputProps={CampoAuxInputProps}
            validations={CampoAuxValidations}
          />
        )
      }
      {
        etichetta2
        && (
          <Input
            className="helpdesk-frontend-scelta-servizio__form-item"
            ref={campoAux2Ref}
            title={etichetta2}
            onChangeValue={onChangeCampo2}
            inputProps={CampoAuxInputProps}
            validations={CampoAuxValidations}
          />
        )
      }
    </>
  );
};

DatiAddizionali.propTypes = {
  campoAux1: PropTypes.string,
  etichetta1: PropTypes.string,
  onChangeCampo1: PropTypes.func.isRequired,
  campoAux2: PropTypes.string,
  etichetta2: PropTypes.string,
  onChangeCampo2: PropTypes.func.isRequired,
};

DatiAddizionali.defaultProps = {
  campoAux1: undefined,
  campoAux2: undefined,
  etichetta1: undefined,
  etichetta2: undefined,
};

export default DatiAddizionali;
